import {requestProduct,requestBase} from '@/utils/request'

// 货主商品审核列表
export function fetchList(data) {
  return requestProduct({
    url: '/seller/shop/product/audit/pageList',
    method: 'post',
    data
  })
}

// 获取品牌、货仓、商品审核列表
export function getVerifyList(data) {
  return requestProduct({
    url: '/application/record/pageList',
    method: 'post',
    data
  })
}

// 获取品牌、货仓、商品申请记录根据ID
export function getApplicationRecordById(data) {
  return requestProduct({
    url: '/application/record/getApplicationRecordById',
    method: 'post',
    data
  })
}


// 获取全部货仓字典列表
export function getWarehouseDicListAll(data) {
  return requestBase({
    url: '/manager/product/warehouse/listAll',
    method: 'post',
    data
  })
}

// 获取货主货仓列表
export function getSellerWarehouseListAll(data) {
  return requestProduct({
    url: '/shop/warehouse/getListAll',
    method: 'post',
    data
  })
}

// 分页获取货主货仓列表
export function getSellerWarehouse(data) {
  return requestProduct({
    url: '/shop/warehouse/pageList',
    method: 'post',
    data
  })
}

// 获取货主货仓列表
export function getProductWarehouseList() {
  return requestProduct({
    url: '/application/record/getWarehouseList',
    method: 'post',
  })
}

// 删除仓库
export function deleteWarehouse(data) {
  return requestProduct({
    url: '/manage/product/product/deleteWarehouse',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/product/verify.js